<template>
   <DocumentsTable
      v-if="accountStore.generalDocs.length"
      :docs="accountStore.generalDocs"
      data-cy="general-documents"
   />
</template>
<script setup lang="ts">
import { useAccountStore } from "@/stores/accountStore";
const accountStore = useAccountStore();
</script>
